import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'

import { authService } from '../infrastructure/services/authService'

export const useSwitchProvider = () => {
  return useMutation({
    mutationFn: (providerId: string) => authService.switchProvider(providerId),
    onSuccess: () => {
      // Full reload: queries, jotai atoms and per-feature filters all hold
      // data scoped to the previous provider and none of them reset on token swap.
      window.location.assign('/')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to switch provider')
    },
  })
}
